import { intakeHref } from '../lib/referral';
import React from 'react';
import { ArrowRight } from 'lucide-react';

const journeySteps = [
  { n: '01', img: '/images/step-assessment.webp', title: 'Take your assessment', body: 'Answer a few questions about your health and weight-loss goals.' },
  { n: '02', img: '/images/step-provider.webp', title: 'Provider review', body: 'A licensed provider reviews your assessment and, if appropriate, prescribes a personalized treatment plan. You\u2019re only charged for treatment after your prescription is approved.' },
  { n: '03', img: '/images/step-delivery.webp', title: 'Delivery to your door', body: 'Your medication is delivered directly to your door, with ongoing support from our care team.' },
];

export default function JourneySteps() {
  return (
    <section id="how" data-testid="how-it-works" className="scroll-mt-24 px-4 sm:px-6 lg:px-12 py-20 sm:py-24">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center max-w-4xl mx-auto">
          <p className="eyebrow">How it works</p>
          <h2 className="mt-5 text-[34px] sm:text-[44px] lg:text-[52px] leading-[1.05] tracking-[-0.03em] text-[color:var(--alfa-ink)]">
            A simpler path to personalized care.
          </h2>
          <p className="mt-4 text-[16px] sm:text-[17px] text-[color:var(--alfa-muted)]">
            Licensed medical care, individualized treatment options, and ongoing support throughout your care journey.
          </p>
        </div>

        <div className="mt-12 sm:mt-14 grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-3">
          {journeySteps.map((s) => (
            <a key={s.n} href={intakeHref()} target="_blank" rel="noopener noreferrer" data-testid={`step-card-${s.n}`} className="step-card group flex gap-5 sm:gap-6 p-2 sm:p-2.5 pr-5 bg-white rounded-md border border-neutral-900/[0.06]">
              <div className="w-[42%] shrink-0 aspect-[4/3] lg:aspect-[4/3.2] overflow-hidden rounded-sm">
                <img src={s.img} alt={s.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
              <div className="py-3 flex-1 min-w-0">
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <p className="text-[14px] text-[color:var(--alfa-gold)]">{s.n}</p>
                    <h3 className="mt-3 text-[19px] sm:text-[20px] leading-tight text-[color:var(--alfa-ink)]">{s.title}</h3>
                  </div>
                  <span className="mt-6 w-9 h-9 rounded-full border border-neutral-900/30 flex items-center justify-center shrink-0 transition-colors group-hover:bg-[color:var(--alfa-ink)] group-hover:text-white">
                    <ArrowRight size={14} />
                  </span>
                </div>
                <p className="mt-4 text-[14px] leading-[1.55] text-[color:var(--alfa-muted)]">{s.body}</p>
              </div>
            </a>
          ))}
        </div>

        <div data-testid="eligibility-cta-card" className="mt-4 lg:mt-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 rounded-md bg-[#1f1e1c] px-6 py-7 sm:px-10 sm:py-8">
          <div>
            <p className="eyebrow">Ready to take the next step?</p>
            <p className="mt-3 text-[26px] sm:text-[30px] lg:text-[34px] leading-[1.1] tracking-[-0.025em] font-light text-[color:var(--alfa-cream)]">
              Find out if you&rsquo;re eligible <span className="text-[color:var(--alfa-gold)]">in just 5 minutes.</span>
            </p>
          </div>
          <a href={intakeHref()} target="_blank" rel="noopener noreferrer" data-testid="eligibility-cta-btn" className="group inline-flex items-center gap-3 shrink-0 rounded-md bg-[color:var(--alfa-cream)] text-[color:var(--alfa-ink)] text-[16px] px-7 py-4 transition-colors hover:bg-white">
            Check my eligibility <ArrowRight size={17} className="transition-transform group-hover:translate-x-1" />
          </a>
        </div>
      </div>
    </section>
  );
}
